import window from 'window-or-global';
import initSearchReplace from './searchreplace';
import initSearchToolbar from './search-toolbar';
import adg3Plugin from './adg3-plugin';

export default function () {
	const plugin = adg3Plugin;

	initSearchReplace();
	initSearchToolbar();
	window.tinymce.create('tinymce.plugins.AtlassianSearchReplacePlugin', plugin());
	window.tinymce.PluginManager.add(
		'searchreplace',
		window.tinymce.plugins.AtlassianSearchReplacePlugin,
	);
}
